"use client"

import React from "react"
import { t } from "@lingui/macro"
import { Icon } from "@silversea-ssc/ui-components-react"
import styles from "./SubFooter.module.scss"

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    })
}

export const ScrollToTopButton: React.FC<React.PropsWithChildren<unknown>> = () => (
    <button onClick={scrollToTop} className={styles.backToTop} title={t`Scroll to top`}>
        <Icon name="arrow-up" size="2.5x" padding={false} className={styles.backToTopIcon} />
    </button>
)
